import { Box, Typography } from "@mui/material";
import { useCelleraTheme } from "theme/useCelleraTheme";

interface PrescriptionCreateSummaryProps {
  formulaTotal: number;
}

export const PrescriptionCreateSummary = ({
  formulaTotal = 0,
}: PrescriptionCreateSummaryProps) => {
  const { colors } = useCelleraTheme();

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(price);
  };

  const total = formulaTotal;

  return (
    <Box
      sx={{
        border: `1px solid ${colors.border.light}`,
        borderRadius: "8px",
        p: "16px",
        backgroundColor: colors.background.paper,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: colors.text.primary,
          mb: 2,
        }}
      >
        Fees & Total Summary
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" sx={{ color: colors.text.secondary }}>
            Subtotal (Supplement):
          </Typography>
          <Typography variant="body2" sx={{ color: colors.text.primary }}>
            {formatPrice(formulaTotal)}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: colors.text.primary,
              fontWeight: 600,
              fontSize: "18px",
            }}
          >
            Total:
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: colors.text.primary,
              fontWeight: 600,
              fontSize: "18px",
            }}
          >
            {formatPrice(total)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
